import styled, { css } from 'styled-components'

import * as COLORS from '../constants/colors'
import * as BREAKPOINT from '../constants/breakpoints'
import * as glyphs from '../icons/glyphs'

import * as button from './button'
import * as copy from './copy'
import * as heading from './heading'

export const Quantity = styled(heading.XXXXXXS)`
  color: ${COLORS.GREY_SHADE_3};
  text-transform: uppercase;
  text-align: right;
`

export const SoldOut = styled(heading.XXXXXXS)`
  color: ${COLORS.GREY_SHADE_3};
  margin: 4px 0 -4px;
  text-transform: uppercase;
`

export const SoonSoldOut = styled(SoldOut)`
  color: ${COLORS.PRIMARY_BLUE_500};
`

export const Description = styled(copy.S.regular)`
  color: ${COLORS.PRIMARY_GREY_900};
  overflow-wrap: anywhere;

  ul {
    padding-left: 40px;
  }

  ul,
  ol {
    margin: 1em 0;
    padding-left: 40px;

    li {
      line-height: 1.618;
    }

    ul,
    ol {
      margin: 0;
    }
  }

  strong {
    font-weight: bold;
  }

  & img {
    max-width: 100%;
  }
`

export const Title = styled(heading.XXXS)`
  color: ${COLORS.PRIMARY_GREY_900};
`

export const Picture = styled.img<{ $format: 'wide' | 'narrow' | 'small' }>`
  max-width: 100%;

  @media screen and ${BREAKPOINT.TABLET} {
    ${({ $format }) => {
      if ($format === 'wide') {
        return css`
          max-width: 70%;
        `
      } else if ($format === 'narrow') {
        return css`
          max-width: 100%;
        `
      } else {
        return css`
          max-width: 132px;
        `
      }
    }}
  }
`

export const Conversion = styled(heading.XXXXXS)`
  color: ${COLORS.TEXT_TERTIARY};

  ${glyphs.Currency} {
    margin-right: 4px;
    color: ${COLORS.PRIMARY_GREY_500};
    vertical-align: bottom;
  }
`

export const OriginalPrice = styled(heading.XS)``

export const Price = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  color: ${COLORS.PRIMARY_BLUE_500};

  ${Conversion} {
    position: relative;
    top: 1px;
  }

  ${OriginalPrice} {
    color: inherit;
    margin-right: 12px;
  }
`

export const Action = styled(heading.XXXXXS)`
  color: ${COLORS.TEXT_SECONDARY};

  ${glyphs.Icon} {
    color: ${COLORS.PRIMARY_GREY_500};
    position: relative;
    top: -2px;
    margin-right: 6px;
  }
`

export const ActiveLabel = styled.span`
  color: ${COLORS.PRIMARY_BLUE_500};
`

export const InactiveLabel = styled.span`
  color: ${COLORS.GREY_SHADE_3};
`

export const ActionButton = styled(button.ActionButton)`
  background-color: ${COLORS.PRIMARY_BLUE_500};

  ${heading.XXXXXS}, ${glyphs.Icon}, ${InactiveLabel}, ${ActiveLabel} {
    color: ${COLORS.PRIMARY_GREY_000};
  }

  ${glyphs.Icon} {
    width: 8px;
  }

  &:hover {
    background-color: ${COLORS.PRIMARY_BLUE_700};
  }
`
